// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13neU","col":"styles_col__3PEiq","actions":"styles_actions__3GEdN","conflict":"styles_conflict__34L3R"};